import React, { useContext, useMemo, useEffect, useState } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import LoadingSpinner from '../LoadingSpinner'

export default function BidWatchlistIcon({
  id,
  watching,
  size = 20,
  zIndex = 30,
  hasCircleBackground = false,
  primary = '#132c52',
  secondary = '#fece62',
}: {
  id?: number
  watching?: boolean
  size?: number
  zIndex?: number
  hasCircleBackground?: boolean
  primary?: string
  secondary?: string
}) {
  const [loading, setLoading] = useState(false)

  const { isLoading } = useContext<any>(AuthContext)

  const circleSize = useMemo(() => size + 10, [size])

  const style = useMemo(
    () =>
      hasCircleBackground ? { width: circleSize, height: circleSize } : {},
    [hasCircleBackground, circleSize]
  )

  useEffect(() => {
    const condition = isLoading && id
    const timeout = setTimeout(
      () => setLoading(condition),
      condition ? 0 : 1000
    )
    return () => {
      clearTimeout(timeout)
    }
  }, [isLoading, id])

  if (loading)
    return (
      <div role="status">
        <LoadingSpinner />
      </div>
    )
  return (
    <div
      className={`z-${zIndex} ${
        hasCircleBackground
          ? 'drop-shadow-[0_2px_1px_rgba(0,0,0,0.5)] bg-white rounded-full flex flex-row justify-center items-center'
          : ''
      }`}
      style={style}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        role="img"
        width={size}
        height={size}
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 472 384"
      >
        <path
          strokeWidth={'1rem'}
          fill={watching ? secondary : primary}
          d="M235 32q79 0 142.5 44.5T469 192q-28 71-91.5 115.5T235 352T92 307.5T0 192q28-71 92-115.5T235 32zm0 267q44 0 75-31.5t31-75.5t-31-75.5T235 85t-75.5 31.5T128 192t31.5 75.5T235 299zm-.5-171q26.5 0 45.5 18.5t19 45.5t-19 45.5t-45.5 18.5t-45-18.5T171 192t18.5-45.5t45-18.5z"
        />
      </svg>
    </div>
  )
}
